setPaymentTokenFailed